import { Stack, Button } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

export interface PageActionsProps {
  /** Primary actions (e.g. "New Transfer") rendered before the export button */
  children?: React.ReactNode;
  /** Called when "Start an export" is clicked. If not provided, export is a no-op. */
  onStartExport?: () => void;
  /** Disable the export button (e.g. while export is in progress) */
  exportDisabled?: boolean;
}

export default function PageActions({
  children,
  onStartExport,
  exportDisabled = false,
}: PageActionsProps) {
  const handleExport = () => {
    onStartExport?.();
  };

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      {children}
      <Button
        variant="outlined"
        startIcon={<FileDownloadOutlinedIcon />}
        onClick={handleExport}
        disabled={exportDisabled}
      >
        Export
      </Button>
    </Stack>
  );
}
